import { render, staticRenderFns } from "./ToReviewStatusButton.vue?vue&type=template&id=50ad8960&scoped=true&"
import script from "./ToReviewStatusButton.vue?vue&type=script&lang=js&"
export * from "./ToReviewStatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad8960",
  null
  
)

export default component.exports